import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./helper/ProtectedRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BottomFooter from "./components/BottomFooter";

import AuthGuard from "./helper/AuthGuard";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePage from "./pages/HomePage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import WishlistPage from "./pages/WishlistPage";
import UserPage from "./pages/UserPage";
import Aboutus from "./components/Aboutus";
import Legal from "./components/Legal";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Media from "./components/Media";
import Events from "./components/Events";
import User from "./components/User";
import Refund_policy from "./components/Refund_policy";
import BankDetalis from "./components/BankDetalis";
import AllAchivers from "./components/AllAchivers";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />
      {/* Common Header */}
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/product-details/:id" element={<ProductDetailsPage />} />

        <Route path="/cart" element={<CartPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog-details" element={<BlogDetailsPage />} />
        {/* <Route path="/blog-details/:id" element={<BlogDetailsPage />} /> */}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/media" element={<Media />} />
        <Route path="/events" element={<Events />} />
        <Route path="/refund" element={<Refund_policy />} />
        <Route path="/all-achivers" element={<AllAchivers />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          {/* <Route path="/user" element={<User />} /> */}
          <Route path="/user" element={<UserPage />} />
          <Route path="/bankdetalis" element={<BankDetalis />} />
        </Route>

        {/* Public (Login Page) */}
        <Route
          path="/account"
          element={
            <AuthGuard>
              <AccountPage />
            </AuthGuard>
          }
        />

        <Route path="*" element={<h1>404 Page Not Found</h1>} />
      </Routes>
      {/* Common Footer */}
      <Footer />
      <BottomFooter />
    </BrowserRouter>
  );
}

export default App;
